module.exports = __webpack_public_path__ + "static/media/services-gear.b1504155.png";